import TopNav from "./Topnav";
import React, { ReactNode } from "react";
import Layoutclass from "./Layout.module.css";
import Demoform from "Pages/Parent/Home/Homepage/requestDemo/Form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdOutlineSupportAgent } from "react-icons/md";

type LayoutProps = {
    children: ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    return (
        <div className={Layoutclass["container"]}>
            <Demoform />
            <TopNav />
            <div className={Layoutclass["help-support-left"]}>
                <button
                    onClick={() =>
                        Navigate(`/Parent/Help-Support?${params.toString()}`)
                    }>
                    <span>Need Help &amp; Support</span>
                    <p className={Layoutclass["icon"]}>
                        <MdOutlineSupportAgent size={18} />
                    </p>
                </button>
            </div>
            <div className={Layoutclass["left"]}>{children}</div>
        </div>
    );
};

export default Layout;
